import { render, staticRenderFns } from "./CitiesList.vue?vue&type=template&id=0b6957be&"
import script from "./CitiesList.vue?vue&type=script&lang=js&"
export * from "./CitiesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports